import { ArticleAdditionalFeedbackTypeNegative } from '@wix/answers-api';
import { Box, Text } from '@wix/design-system';
import { useTranslation } from '@wix/wix-i18n-config';

import { DATA_HOOKS } from '../../../../dataHooks';

import css from './index.module.scss';

type UnhelpfulFeedbackOptionsProps = {
  setUnhelpfulFeedbackOptionSelected: (unhelpfulFeedbackOption: ArticleAdditionalFeedbackTypeNegative) => void;
};

export const UnhelpfulFeedbackOptions = ({ setUnhelpfulFeedbackOptionSelected }: UnhelpfulFeedbackOptionsProps) => {
  const { t } = useTranslation();

  return (
    <Box gap={1} direction="vertical" dataHook={DATA_HOOKS.UNHELPFUL_OPTIONS}>
      {Object.values(ArticleAdditionalFeedbackTypeNegative)
        .filter(value => typeof value === 'number')
        .map(unhelpfulFeedbackOption => (
          <div
            /* TODO: add functionality for getting to chatbot when user click options other than OTHER */
            onClick={() => setUnhelpfulFeedbackOptionSelected(unhelpfulFeedbackOption)}
            key={unhelpfulFeedbackOption}
            data-hook={DATA_HOOKS.UNHELPFUL_FEEDBACK_OPTION}>
            <Box className={css.negativeFeedbackOption}>
              <Text size="tiny">
                {t(`article-feedback.additional.unhelpful.option.${unhelpfulFeedbackOption}`)}
              </Text>
            </Box>
          </div>
        ))}
    </Box>
  );
};
